<script setup>
import Icon from '@components/Icon.vue'
import Spinner from '@components/Spinner.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import { ref } from 'vue'
import api from '@helpers/api'
import { generateRecaptchaToken } from '@helpers/utils'

const failed = ref(false)
const submitted = ref(false)
const submitting = ref(false)

async function contact(e) {
  const formData = new FormData(e.target)
  const plainFormData = Object.fromEntries(formData.entries())

  failed.value = false
  submitted.value = false
  submitting.value = true

  plainFormData.captcha = await generateRecaptchaToken('contact')

  api
      .post('/contact', plainFormData)
      .then(() => {
        e.target.reset()
        submitted.value = true
      })
      .catch(() => {
        failed.value = true
      })
      .finally(() => {
        submitting.value = false
      })
}
</script>

<template>
  <div>
    <div v-if="failed" class="alert alert--error">
      <Icon type="error" />
      <span>There was an issue submitting your message. Please try again later.</span>
    </div>

    <div v-if="submitted" class="alert alert--success">
      <Icon type="success" />
      <span>Success! Your email has been sent. Please give us up to 2 business days to respond. Thank you!</span>
    </div>

    <form @submit.prevent="contact">
      <slot />

      <div class="contact__button">
        <PrimaryButton type="submit" class="button" :disabled="submitting">
          <span v-if="!submitting">Send Message</span>
          <Spinner color="white" v-else />
        </PrimaryButton>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
.button {
  margin-top: 16px;

  @media screen and (min-width: 768px) {
    margin-top: 32px;
  }
}
</style>
